import {
    GET_ROF_BURNS_BATCH_DATA_SUCCESS,
    GET_ROF_BURNS_BATCH_DATA_FAIL,
    GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_SUCCESS,
    GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_FAIL,
    GET_ROF_BURNS_BATCH_VOLUMES_SUCCESS,
    GET_ROF_BURNS_BATCH_VOLUMES_FAIL,
    GET_ROF_BURNS_BATCH_BULK_DENSITY_SUCCESS,
    GET_ROF_BURNS_BATCH_BULK_DENSITY_FAIL,
    GET_ROF_BURNS_BIOCHAR_MASS_SUCCESS,
    GET_ROF_BURNS_BIOCHAR_MASS_FAIL,
    POST_ROF_BURNS_LAB_REPORT_FILE_SUCCESS,
    POST_ROF_BURNS_LAB_REPORT_FILE_FAIL,
    GET_ROF_BURNS_LAB_REPORT_FILES_SUCCESS,
    GET_ROF_BURNS_LAB_REPORT_FILES_FAIL,
    POST_BASE_LOG_KILN_SUCCESS,
    POST_BASE_LOG_KILN_FAIL,
    GET_BASE_LOG_KILNS_SUCCESS,
    GET_BASE_LOG_KILNS_FAIL,
    GET_ROF_BURNS_BATCH_MEDIA_SUCCESS,
    GET_ROF_BURNS_BATCH_MEDIA_FAIL,
    GET_PROJECT_BATCHES_SUCCESS,
    GET_PROJECT_BATCHES_FAIL,
    GET_DOWNLOAD_BATCH_REPORT_SUCCESS,
    GET_DOWNLOAD_BATCH_REPORT_FAIL,
    POST_BASE_BUCKET_SUCCESS,
    POST_BASE_BUCKET_FAIL,
    GET_BASE_BUCKETS_SUCCESS,
    GET_BASE_BUCKETS_FAIL,
    POST_BASE_EQUIPMENT_SUCCESS,
    POST_BASE_EQUIPMENT_FAIL,
    GET_BASE_EQUIPMENT_SUCCESS,
    GET_BASE_EQUIPMENT_FAIL,
    API_GET_APPLICATION_TYPE_SUCCESS,
    API_GET_APPLICATION_TYPE_FAIL,
    GET_ROF_BURNS_USERS_SUCCESS,
    GET_ROF_BURNS_USERS_FAIL,
    GET_FARM_PROJECTS_SUCCESS,
    GET_FARM_PROJECTS_FAIL,
    ADD_USER_TO_PROJECT_SUCCESS,
    ADD_USER_TO_PROJECT_FAIL,
    GET_PROJECT_INFO_SUCCESS,
    GET_PROJECT_INFO_FAIL,
    POST_PROJECT_INFO_SUCCESS,
    POST_PROJECT_INFO_FAIL,
    GET_BIOCHAR_LAB_SAMPLES_SUCCESS,
    GET_BIOCHAR_LAB_SAMPLES_FAIL,
    POST_BIOCHAR_LAB_SAMPLES_SUCCESS,
    POST_BIOCHAR_LAB_SAMPLES_FAIL,
    GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
    GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
    POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
    POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
    GET_IGNITION_FUEL_SUCCESS,
    GET_IGNITION_FUEL_FAIL,
    POST_IGNITION_FUEL_SUCCESS,
    POST_IGNITION_FUEL_FAIL,
    GET_EQUIPMENT_TRANSPORT_SUCCESS,
    GET_EQUIPMENT_TRANSPORT_FAIL,
    POST_EQUIPMENT_TRANSPORT_SUCCESS,
    POST_EQUIPMENT_TRANSPORT_FAIL
} from '../../actions/rof-burns/types/rof-burn-types';
import { SET_SELECTED_RROJECT_FAIL, SET_SELECTED_RROJECT_SUCCESS } from '../../actions/types';

const initialState = {
    loading: true,
    batchData: [],
    batchMedia: [],
    additionalBatchData: [],
    batchVolumes: [],
    bulkDensity: [],
    biocharMass: [],
    batchCarbonContent: [],
    biocharStoredCarbon: [],
    labReportFiles: [],
    logKilns: [],
    projectBatches: [],
    buckets: [],
    equipment: [],
    applicationTypes: [],
    rofBurnsUsers: [],
    farmProjects: [],
    projectInfo: [],
    biocharLabSamples: [],
    biocharLabSamplesContaminants: [],
    ignitionFuel: [],
    equipmentTransport: [],
};

export default function rofBurnsReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ROF_BURNS_BATCH_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                batchData: payload
            };
        case GET_ROF_BURNS_BATCH_DATA_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                additionalBatchData: payload
            };
        case GET_ROF_BURNS_ADDITIONAL_BATCH_DATA_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_ROF_BURNS_BATCH_VOLUMES_SUCCESS:
            return {
                ...state,
                loading: false,
                batchVolumes: payload
            };
        case GET_ROF_BURNS_BATCH_VOLUMES_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_ROF_BURNS_BATCH_BULK_DENSITY_SUCCESS:
            return {
                ...state,
                loading: false,
                bulkDensity: payload
            };
        case GET_ROF_BURNS_BATCH_BULK_DENSITY_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_ROF_BURNS_BIOCHAR_MASS_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharMass: payload
            };
        case GET_ROF_BURNS_BIOCHAR_MASS_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_ROF_BURNS_LAB_REPORT_FILE_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_ROF_BURNS_LAB_REPORT_FILE_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_ROF_BURNS_LAB_REPORT_FILES_SUCCESS:
            return {
                ...state,
                labReportFiles: payload,
                loading: false
            };
        case GET_ROF_BURNS_LAB_REPORT_FILES_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_BASE_LOG_KILN_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_BASE_LOG_KILN_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BASE_LOG_KILNS_SUCCESS:
            return {
                ...state,
                loading: false,
                logKilns: payload
            };
        case GET_BASE_LOG_KILNS_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_ROF_BURNS_BATCH_MEDIA_SUCCESS:
            return {
                ...state,
                loading: false,
                batchMedia: payload
            };
        case GET_ROF_BURNS_BATCH_MEDIA_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_PROJECT_BATCHES_SUCCESS:
            return {
                ...state,
                loading: false,
                projectBatches: payload
            };
        case GET_PROJECT_BATCHES_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_DOWNLOAD_BATCH_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                projectBatches: payload
            };
        case GET_DOWNLOAD_BATCH_REPORT_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_BASE_BUCKET_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_BASE_BUCKET_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BASE_BUCKETS_SUCCESS:
            return {
                ...state,
                loading: false,
                buckets: payload
            };
        case GET_BASE_BUCKETS_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_BASE_EQUIPMENT_SUCCESS:
        case POST_BASE_EQUIPMENT_FAIL:
        case GET_BASE_EQUIPMENT_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BASE_EQUIPMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                equipment: payload
            };
        case API_GET_APPLICATION_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                applicationTypes: payload
            };
        case API_GET_APPLICATION_TYPE_FAIL:
            return {
                ...state,
                loading: false
            };
        case SET_SELECTED_RROJECT_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedProject: payload
            };
        case SET_SELECTED_RROJECT_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_ROF_BURNS_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                rofBurnsUsers: payload
            };
        case GET_ROF_BURNS_USERS_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_FARM_PROJECTS_SUCCESS:
            return {
                ...state,
                loading: false,
                farmProjects: payload
            };
        case GET_FARM_PROJECTS_FAIL:
            return {
                ...state,
                loading: false
            };
        case ADD_USER_TO_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case ADD_USER_TO_PROJECT_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_PROJECT_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                projectInfo: payload
            };
        case GET_PROJECT_INFO_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_PROJECT_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                projectInfo: payload
            };
        case POST_PROJECT_INFO_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BIOCHAR_LAB_SAMPLES_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharLabSamples: payload
            };
        case GET_BIOCHAR_LAB_SAMPLES_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_BIOCHAR_LAB_SAMPLES_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_BIOCHAR_LAB_SAMPLES_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharLabSamplesContaminants: payload
            };
        case GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_IGNITION_FUEL_SUCCESS:
            return {
                ...state,
                loading: false,
                ignitionFuel: payload
            };
        case GET_IGNITION_FUEL_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_IGNITION_FUEL_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_IGNITION_FUEL_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_EQUIPMENT_TRANSPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                equipmentTransport: payload
            };
        case GET_EQUIPMENT_TRANSPORT_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_EQUIPMENT_TRANSPORT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_EQUIPMENT_TRANSPORT_FAIL:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}